import React from 'react';

import AnonymousMessagesPageContent
  from 'components/dashboard/anonymous-messages-content/AnonymousMessagesPageContent';

const DashboardAnonymousMessagesPage = () => <AnonymousMessagesPageContent />;

export default DashboardAnonymousMessagesPage;
